import React from 'react';
import SEO from '../components/SEO';
import { organizationSchema, localBusinessSchema, websiteSchema } from '../data/structuredData';
import HeroSection from '../components/home/HeroSection';
import CoreStrengthsSection from '../components/home/CoreStrengthsSection';
import FeaturedProductsSection from '../components/home/FeaturedProductsSection';
import IndustriesSection from '../components/home/IndustriesSection';
import ClientsSection from '../components/home/ClientsSection';
import CTASection from '../components/home/CTASection';

const Home = () => (
  <div className="min-h-screen bg-[#f9fafb] overflow-hidden">
    <SEO
      title="Industrial Machine Guards, Dust Suppression & Wear Resistance | Stallion Bulktech"
      description="Stallion Bulktech delivers industrial machine guards, dust suppression systems, and wear resistance solutions for mining, cement, power, and bulk handling industries. Improve safety, reduce wear, and minimize downtime."
      path="/"
      jsonLd={{
        '@context': 'https://schema.org',
        '@graph': [organizationSchema, localBusinessSchema, websiteSchema],
      }}
    />
    <HeroSection />
    <CoreStrengthsSection />
    <FeaturedProductsSection />
    <IndustriesSection />
    <ClientsSection />
    <CTASection />
  </div>
);

export default Home;
